jQuery(function ($) {
    if ( $('.header__menu-button').length ) {
        let scrollPos;
        $('.header__menu-button').on('click', function(){
            if ( $('.header__menu-button').hasClass('is-close') ) {
                $('.hamburger').fadeOut();
                $('.header__menu-button').removeClass('is-close');
                $('body').attr('style','');
                $('html, body').prop({scrollTop: scrollPos});
            } else {
                $('.hamburger').fadeIn();
                $('.header__menu-button').addClass('is-close');
                scrollPos = $(window).scrollTop();
                $('body').css({
                    width: '100%',
                    position: 'fixed',
                    top: -1 * scrollPos + 'px'
                });
            }
        });
    }
});